/**
 * Event Timeline API helper (GW-8065)
 *
 * GW-8630: this module previously fetched a mission's products via
 * `MissionsClient.getProducts()` (`GET /v1/missions/{missionId}/products`)
 * to locate and map a PROD-CORE-005 record for a given run. That route was
 * never implemented by gw-missions-api (confirmed dead — see PACT.md), so
 * the fetch/map path was permanently unreachable and has been removed.
 * `emptyEventTimelineProduct` remains: it is the real, live fallback
 * `missionRunResultsSlice.ts` returns for PROD-CORE-005 today.
 */

import type { EventTimelineProduct } from '@gw/ui/types';

/**
 * Honest empty PROD-CORE-005 assembly. Empty date-range strings are the
 * documented signal `EventTimelinePage` uses to render "no events
 * extracted" in its date-range stat — this is the correct representation
 * of "no event-timeline content available yet", not a fabricated
 * placeholder.
 */
export function emptyEventTimelineProduct(): EventTimelineProduct {
  return {
    product_id: 'PROD-CORE-005',
    event_entries: [],
    date_range_earliest: '',
    date_range_latest: '',
    total_event_count: 0,
  };
}
